export default __webpack_public_path__ + "identity_verification_welcome_splash.png";